import React from 'react'
import { observer } from 'mobx-react'
import _ from 'lodash'
import Series from './Series'

const SeriesList = ({
  seriesNames,
  height,
  xScale,
  yScale,
  analysis,
  color
}) => (
  <g>
    {
      _.map(seriesNames, (name, i) => (
        <Series
          key={name}
          color={color}
          seriesName={name}
          i={i}
          numSeries={seriesNames.length}
          height={height}
          xScale={xScale}
          yScale={yScale}
          analysis={analysis}
        />
      ))
    }
  </g>
)

export default observer(SeriesList)
